import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { DOSSIERS_REDUCER_NAME } from './constants';
import { buildDossiersRedux } from './dossiersReducer';

const { reducer } = buildDossiersRedux({});

export const dossiersReducer = combineReducers({
    [DOSSIERS_REDUCER_NAME]: reducer,
});

export const legalAnnoucementDossierStore = configureStore({
    reducer: dossiersReducer,
    devTools: {
        name: 'Dossiers Store',
    },
});

export type DossiersReducerType = typeof dossiersReducer;
export type DossiersStateType = ReturnType<typeof legalAnnoucementDossierStore.getState>;
export type DossiersAppDispatch = typeof legalAnnoucementDossierStore.dispatch;
